import accordionReducer, {
    AccordionActions,
} from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionReducer";
import formReducer, { FormActions } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormReducer";
import { combineReducers } from "redux";

const componentsReducer = combineReducers({
    accordion: accordionReducer,
    form: formReducer,
});

export type ComponentsActions = FormActions | AccordionActions;

export default componentsReducer;
